if (!customElements.get('rb-button')) {
  class RechargeVariantButton extends HTMLElement {
    connectedCallback() {
      document.addEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.addEventListener('recharge:progress', this.onProgressChange.bind(this));
      this.addEventListener("click", this.onClickHandler.bind(this));
    }
    
    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
      document.removeEventListener('recharge:progress', this.onProgressChange.bind(this));
    }

    onRechargeReady() {
      this.addEventListener('click', this.onClick.bind(this));

      setTimeout(() => {
        this.updateSelect();
        this.hidden = false;

        //Check for Variants in URL
        this.updateVariantByUrl();
        
        //Change
        this.updateDeliverySelect();
      }, 100)
    }

    onProgressChange(event) {
      const { value } = event.detail;
      this.disabled = value > this.meal
    }

    onClickHandler(event){
      this.setVariantURL(this.title);
    }

    setVariantURL(title){
      const params = new URLSearchParams(window.location.search);
      params.set('variant', title);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, '', newUrl);
    }

    updateVariantByUrl() {
      const params = new URLSearchParams(window.location.search);
      const variant = params.get('variant').toLocaleLowerCase();

      if(!variant) {
        return;
      }

      const target = document.querySelector(`rb-button[title="${variant}"]`);
      if(target.hasAttribute('active')) {
        return;
      }

      target.click();
    }

    updateDeliverySelect() {
      if(!this.delivery || !this.active) {
        return;
      }

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('recharge:delivery:update', {
          detail: this.delivery
        }))
      }, 400)
    }

    get title() {
      return this.getAttribute('title')
    }

    get percentage() {
      return this.getAttribute('percentage')
    }

    get price() {
      return this.getAttribute('price')
    }

    get disabled() {
      return this.hasAttribute('disabled')
    }

    set disabled(value) {
      return value ? this.setAttribute('disabled', true) : this.removeAttribute('disabled')
    }
    
    get meal() {
      return Number(this.title.replace(/[^0-9.-]+/g, ''))
    }

    get values() {
      return {
        id: this.id,
        title: this.title,
        price: this.price,
        percentage: this.percentage,
      }
    }

    get active() {
      return this.hasAttribute('active')
    }

    set active(flag) {
      if(flag) {
        this.setAttribute('active', true)
      } else {
        this.removeAttribute('active');
      }
    }

    get hidden() {
      return this.hasAttribute('hidden')
    }

    set hidden(flag) {
      if(flag) {
        this.setAttribute('hidden', true)
      } else {
        this.removeAttribute('hidden');
      }
    }

    get delivery() {
      return this.hasAttribute('delivery') ? this.getAttribute('delivery') : false
    }

    updateSelect() {
      const select = document.querySelector('#product-variant-list');
      const button = document.querySelector('rb-button[active]');
      if(!select || !button) {
        return;
      }
      
      //Set Value based on Title
      select.value = button.title;

      //Dispatch Event for Recharge
      select.dispatchEvent(new Event('change'));
    }

    onClick(e) {
      if(this.active || this.disabled) {
        return;
      }

      //Dispatch Global Event
      this.dispatchEvent();

      //Update buttons
      this.variants = document.querySelectorAll('rb-button');
      this.variants.forEach((variant) => (variant.active = false));

      this.active = !this.active

      //Update Select
      this.updateSelect();

      //Update Delivery
      this.updateDeliverySelect();
    }

    dispatchEvent() {
      document.dispatchEvent(new CustomEvent('recharge:variant', {
        detail: this.values
      }))
    }
  }
  customElements.define('rb-button', RechargeVariantButton);

  class RechargeSwitchButton extends HTMLElement {
    constructor() {
      super();

      this.checkbox = false
    }

    connectedCallback() {
      document.addEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
    }
    
    disconnectedCallback() {
      document.removeEventListener("bundling-widget:ready", this.onRechargeReady.bind(this));
    }

    onRechargeReady() {
      this.addEventListener('click', this.onClick.bind(this));

      setTimeout(() => {
        this.checkbox = document.querySelector('rb-delivery .rb-switch');
        this.checkboxInput = document.querySelector('rb-delivery .rb-switch input[type="checkbox"]');
        if(this.checkboxInput) {
          this.checkboxInput.addEventListener('change', this.onCheckboxChange.bind(this));
        }
      }, 100)
    }


    updateCheckbox() {
      if(!this.active) {
        return;
      }
    }

    onCheckboxChange() {
      //Ignore programmatic toggles done by rb-amount.dispatchEvent to read both prices.
      if(window._rechargeAboTogglePending) {
        return;
      }

      const desiredType = this.checkboxInput.checked ? 'price' : 'compare-at-price';
      const shouldBeActive = this.type === desiredType;

      if(shouldBeActive === this.active) {
        return;
      }

      if(shouldBeActive) {
        this.variants = document.querySelectorAll('rb-switch-button');
        this.variants.forEach((variant) => (variant.active = false));
        this.active = true;
        this.togglePrices();
      }
    }

    get disabled() {
      return this.hasAttribute('disabled')
    }

    set disabled(value) {
      return value ? this.setAttribute('disabled', true) : this.removeAttribute('disabled')
    }

    get active() {
      return this.hasAttribute('active')
    }

    set active(flag) {
      if(flag) {
        this.setAttribute('active', true)
      } else {
        this.removeAttribute('active');
      }
    }

    get type() {
      return this.querySelector('[data-compare-at-price]') ? 'compare-at-price' : 'price';
    }

    togglePrices() {
      const elements = Array.from(document.querySelectorAll('[data-toggle-prices]'));
      elements.forEach(element => element.removeAttribute('hidden'));

      elements.filter(element => element.dataset.togglePrices !== this.type).forEach(element => element.setAttribute('hidden', true))
    }

    onClick(e) {
      if(this.active || this.disabled) {
        return;
      }

      //Update buttons
      this.variants = document.querySelectorAll('rb-switch-button');
      this.variants.forEach((variant) => (variant.active = false));

      this.active = !this.active

      //Update Select
      this.checkbox.click();

      //Toggle Price
      this.togglePrices();
    }
  }
  customElements.define('rb-switch-button', RechargeSwitchButton);
}